
import { Input } from "element-ui"
import { showGlobalMessage, openNoAddressPop } from "@/utils/utils"
import { handleModifyCartV2 } from "@/utils/cartResponse"

export default {
  name: "WareViewInputNumber",
  components: {
    [Input.name]: Input
  },
  inject: {
    getStoreId: {
      default: null
    },
    source: {
      default: null
    }
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    sku: {
      type: [Number, String],
      default: ""
    },
    skuType: {
      type: [Number, String],
      default: ""
    },
    maxlength: {
      type: Number,
      default: 2
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    },
    ware: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      curValue: this.value,
      focused: false
    }
  },
  computed: {
    increaseDisabled() {
      return Number(this.curValue) >= 99
    }
  },
  watch: {
    value() {
      this.curValue = this.value
    },
    curValue(newVal, oldValue) {
      this.oldValue = oldValue
    }
  },
  created() {
    if (!process.client) {
      return
    }
    const { commonReqParams } = this.$commonParams
    this.storeId = this.getStoreId ? this.getStoreId() : commonReqParams.storeId
  },
  methods: {
    handleInput(value) {
      this.curValue = value.replace(/[^\d]/g, "")
      if (this.curValue == 0) {
        this.curValue = ""
      }
    },
    handleBlur() {
      this.focused = false
      this.$emit("handleBlur", this.curValue)
    },
    handleFocus() {
      // 激活输入框的时候，将数据
      this.$emit("handleFocus")
      this.focused = true
    },
    async reduce() {
      const num = Number(this.curValue) - 1
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data] = await handleModifyCartV2({
        storeId: this.storeId,
        wares: [{ sku: this.sku, beforeCount: this.curValue, count: num, checked: 1 }],
        sort: 1
      })
      if (error) {
        this.afterAddCardError(error)
      }
      if (data) {
        this.afterAddCard(data, num)
      }
      loading.close()
    },
    async increase() {
      if (this.increaseDisabled) return
      const num = Number(this.curValue) + 1
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data] = await handleModifyCartV2({
        storeId: this.storeId,
        wares: [{ sku: this.sku, beforeCount: this.curValue, count: num, checked: 1 }],
        sort: 1
      })
      if (error) {
        this.afterAddCardError(error)
      }
      if (data) {
        this.afterAddCard(data, num)
      }
      loading.close()
    },
    handleEmit(value) {
      if (value === "") {
        this.curValue = value = this.min
      }
      // console.log("value===>", Number(value), this.curValue)
      if (this.focused) {
        this.$refs.input && this.$refs.input.blur()
      }
      this.$emit("changed", Number(value))
      this.$bus.$emit("add-cart-success", this.source)
      if (this.source === "collect") {
        this.$bus.$emit("reload-collect")
      }
    },
    async handleChange(num) {
      if (num === "") {
        num = this.min
      }
      if (num > this.max) {
        showGlobalMessage({
          message: this.$t("cart.maximumStockTips"),
          gap: 150,
          iconClass: "messageWarning"
        })
        num = this.max
      }
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data] = await handleModifyCartV2({
        storeId: this.storeId,
        wares: [{ sku: this.sku, beforeCount: this.value, count: num, checked: 1 }],
        sort: 1
      })
      if (error) {
        this.afterAddCardError(error)
      }
      if (data) {
        this.afterAddCard(data, num)
      }
      loading.close()
    },
    afterAddCardError(error) {
      this.curValue = this.value
      if (error && error.code == "44999") {
        openNoAddressPop()
      } else {
        // this.$message.error(error.result)
      }
    },
    afterAddCard(res, num) {
      this.curValue = num
      this.handleEmit(this.curValue)
      // if (res.adequateStock) {
      //   this.curValue = num;
      //   this.handleEmit(this.curValue);
      // } else {
      //   this.curValue = this.value;
      //   showGlobalMessage({
      //     message: this.$t('cart.maximumStockTips'),
      //     gap: 150,
      //     iconClass: 'messageWarning'
      //   });
      // }
    }
  }
}
